import { useContext } from 'react'

import { AppContext } from '@assembly/contexts/App/app.context'

const useAppStore = () => useContext(AppContext)

export default useAppStore
